<template>
  <nav class="nav">
    <div class="nav-content">
      <router-link to="/" class="logo">
        <img
          id="getLogo"
          src="../assets/get-academy.png"
          alt="GET Academy logo"
        />
      </router-link>
      <div class="menu-items">
        <!-- <MenuItem
          v-if="$auth.isAuthenticated"
          to="/søk"
          tabindex="1"
          text="Søke liste"
        /> -->

        <Dropdown tabindex="2"></Dropdown>

        <!-- <MenuItem
          v-if="$auth.isAuthenticated"
          to="/obligatoriske-oppgaver"
          tabindex="3"
          text="Kurs"
        />

        <MenuItem
          v-if="$auth.isAuthenticated"
          to="/profil"
          tabindex="4"
          text="Profil"
        />
        <span v-if="!$auth.loading">
          <a
            v-if="!$auth.isAuthenticated"
            tabindex="5"
            @click="login"
            class="menu-item"
          >
            <span>Logg inn</span>
          </a>
          <a
            v-if="$auth.isAuthenticated"
            tabindex="5"
            @click="logout"
            class="menu-item"
          >
            <span>Logg ut</span>
          </a>
        </span> -->
      </div>
    </div>
  </nav>
</template>

<script>
// import MenuItem from "@/components/MenuItem.vue";
import Dropdown from "@/components/Dropdown.vue";

export default {
  name: "NavBar",
  components: {
    // MenuItem,
    Dropdown,
  },
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.nav {
  height: 4em;
  font-weight: bold;
  color: var(--dark-color);
  background-color: var(--white-color);
  box-shadow: rgba(96, 95, 95, 0.2) 0px 5px 10px;

  .nav-content {
    max-width: var(--content-width);
    margin: auto;
    display: flex;
    justify-content: space-between;
  }
}

a {
  border: 0;
}

.logo {
  float: left;
  $padding: 0.45em;
  text-decoration: none;
  // margin: 0 var(--margin-sides);
  margin: auto 0;
  & > span {
    color: var(--primary-color) !important;
    font-size: 1.45em;
    // display: inline-block;
    padding: $padding 0;
  }
}

#getLogo {
  padding-top: 0.5em;
  width: 7em;
}

.menu-items {
  display: flex;
  flex-direction: row;
  float: right;
  margin: 0 var(--margin-sides);
}

@media only screen and (max-width: 768px) {
  #getLogo {
    padding: 0.5em;
  }
}
</style>

<style lang="scss">
.menu-item {
  cursor: pointer;

  &.router-link-exact-active span {
    border-bottom: 4px solid var(--primary-color);
  }

  &:hover span {
    border-bottom: 4px solid var(--primary-color);
  }

  * {
    padding-left: 1em;
    padding-right: 1em;
  }

  // For tekst
  span {
    $padding: 1.2em;

    display: inline-block;
    padding-top: $padding;
    padding-bottom: $padding;
  }

  // For ikoner
  img {
    $padding: 0.5em;

    height: 2em;
    padding-top: $padding;
    padding-bottom: $padding;
  }
}
</style>